import { useContext } from 'react'
import { ModalContext } from '../ModalContext'

export default function TimelineColumnSettingsModal() {

    const { modalData } = useContext(ModalContext)
    const { column } = modalData

    // console.log(column)

    return (
        <>
            <div>Timeline Column Settings</div>

            <div className='flex gap-x-4'>
                {column?.assumptionTrace?.map((assumption, index) => (
                    <div
                        key={index}
                        className='border border-gray-400 rounded-md p-2 space-y-2 w-64'
                    >
                        {/* <pre className='text-left'>{JSON.stringify(assumption, null, 2)}</pre> */}
                        <p className='text-sm'>{assumption.date}</p>
                        <p className='text-sm'>{assumption.isoWeekKey}</p>

                        <div className='grid grid-cols-3 gap-x-2'>
                            <p className='pl-2 text-left'>Goal</p>
                            <p>ISO Occ.</p>
                            <p>Occ.</p>
                        </div>

                        <div className='space-y-1'>
                            {assumption.rankedGoals.map((goal, index) => (
                                <div
                                    key={index}
                                    className={`
                                        grid grid-cols-3 gap-x-2
                                        ${index === 0 || index === 1 ? 'ring-1 ring-gray-400 ring-inset rounded-lg' : ''}
                                    `}
                                >
                                    <p className='pl-2 text-left'>{goal.name}</p>
                                    <p>{goal.isoWeekOccurrences}</p>
                                    <p>{goal.occurrences}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                <div className='border border-orange-400 bg-orange-50 rounded-md p-2 space-y-2 w-64'>
                    <p className='text-sm'>{column.isoDate}</p>
                    <p className='text-sm'>Current Week</p>

                    <div className='grid grid-cols-3 gap-x-2'>
                        <p className='pl-2 text-left'>Goal</p>
                        <p>ISO Occ.</p>
                        <p>Occ.</p>
                    </div>

                    <div className='space-y-1'>
                        {column.rankedGoals.map((goal, index) => (
                            <div 
                                key={index}
                                className={`
                                    grid grid-cols-3 gap-x-2
                                    ${index === 0 || index === 1 ? 'ring-1 ring-orange-400 ring-inset rounded-lg' : ''}
                                `}
                            >
                                <p className='pl-2 text-left flex-grow'>{goal.name}</p>
                                <p>{goal.isoWeekOccurrences}</p>
                                <p>{goal.occurrences}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
